import React from 'react';

import ResetPasswordForm from '../../components/ResetPasswordForm';

function ResetPassword() {
  return (
    <div className="crce-login-root">
      <div className="crce-login-right">
        <div className="crce-login-form-card">
          <ResetPasswordForm />
        </div>
      </div>
    </div>
  );
}

export default ResetPassword;
